import React, {useEffect} from 'react'
import { Col, Row } from 'antd'
import { connect } from 'react-redux'
import Layout from '../../components/Layout'
import actions from '../../redux/actions'
import Divider from '../../components/Divider'
import styled from 'styled-components'
import countryData from '../../assets/data/country.json';

const Text = styled.p`
  font-size: 18px;
  line-height: 24.3px;
`

const StyledCol = styled(Col)`
  margin: 1rem 0 !important;
`

const Country = (props) => {
  const handleClick = (id,value) => {
    props.setSpouseCountry(id,value);
    props.setSpouseNationality("Other");
    props.history.goBack();
  }

  useEffect(() => window.scrollTo(0,0));

  return (
    <Layout title={'ประเทศ'} backIcon={true} onClick={() => props.history.goBack()}>
      <h4 style={{marginTop: '2rem', marginBottom: '1rem'}}>กรุณาเลือกประเทศ</h4>
      <Row>
        {
          countryData.map(element =>
            <StyledCol key={element.id}>
              <Text onClick={() => handleClick(element.id,element.th)}>{element.th}</Text>
              <Divider floatRight={true}/>
            </StyledCol>
          )
        }
      </Row>
    </Layout>
  )
}

const mapDispatchToProps = {
  setSpouseCountry: actions.setSpouseCountry,
  setSpouseNationality: actions.setSpouseNationality,
}

const CountryWithConnect = connect(null, mapDispatchToProps)(Country)

export default CountryWithConnect
